import { render, staticRenderFns } from "./CaptureDriversLicenseFront.vue?vue&type=template&id=f63df610&"
import script from "./CaptureDriversLicenseFront.vue?vue&type=script&lang=ts&"
export * from "./CaptureDriversLicenseFront.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports